var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup412(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    transform: "translate(-216 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    transform: "translate(-838.222 213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79",
    fill: "#8aa385",
    stroke: "#748d6f",
    transform: "translate(1061.222 35)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18,
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bell",
    fill: "#fff",
    d: "M19.394 15.991c-.853-.916-2.448-2.295-2.448-6.81A6.97 6.97 0 0 0 11.3 2.332v-.92a1.412 1.412 0 1 0-2.823 0v.92a6.97 6.97 0 0 0-5.649 6.849c0 4.515-1.6 5.894-2.448 6.81a1.379 1.379 0 0 0-.38.958 1.414 1.414 0 0 0 1.417 1.412h16.94a1.413 1.413 0 0 0 1.417-1.412 1.378 1.378 0 0 0-.38-.958zm-16.414.252c.937-1.235 1.961-3.281 1.966-7.037V9.18a4.944 4.944 0 1 1 9.887 0v.026c0 3.756 1.029 5.8 1.966 7.037zM9.887 22.6a2.824 2.824 0 0 0 2.824-2.825H7.064A2.824 2.824 0 0 0 9.887 22.6z",
    transform: "rotate(30 465.493 2029.113)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_648",
    d: "M0 0H50V50H0z",
    className: "cls-3",
    transform: "translate(216 241)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup412);
export default __webpack_public_path__ + "static/media/Group 412.6abd9bfa625370fe15ec05385ecd3084.svg";
export { ForwardRef as ReactComponent };